module.exports = __webpack_public_path__ + "img/electronic_use.2636fb46.svg";